<template>
  <div :class="`ctn-button-${typeLogin}`">
    <button
      ref="buttonGame"
      class="button-game"
      @click="buttonToggle()"
      @touch="buttonToggle()"
      :style="{
        background: colors && colors.secondary,
        borderTop: colors && `7px solid ${colors.secondary}`,
        borderBottom: 'transparent',
        color:'#fff'
      }"
    >
      <img
        class="img-social"
        src="../../assets/facebook-icon.png"
        alt
        v-if="typeLogin == 'social' && social == 'facebook'"
      />
      <img
        class="img-social"
        src="../../assets/google-icon.png"
        alt
        v-if="typeLogin == 'social' && social == 'google'"
      />
      <span class="text-button" v-if="typeLogin == 'social'">
        Login com
        <span>{{ social }}</span>
      </span>
      <span class="text-button email" v-if="typeLogin == 'email' || typeLogin == 'default'">
        {{
        name
        }}
      </span>
    </button>
  </div>
</template>
<script>
import Bus from "@/main.js";
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    typeLogin: {
      type: String,
      required: true
    },
    social: {
      type: String,
      required: false
    },
    action: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      classStart: "",
      classFinish: "",
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    this.game = localStorage.getItem("game-redirect");
  },
  mounted() {
    let type = this.typeLogin;
    let social = this.social;
    let buttonGame = this.$refs.buttonGame;

    // if (type == "social") {
    //   if (social == "facebook") {
    //     buttonGame.classList.add("created-facebook");
    //   } else if (social == "google") {
    //     buttonGame.classList.add("created-google");
    //   }
    // } else if (type == "email") {
    //   buttonGame.classList.add("created-email");
    //   document.querySelector(".ctn-button-email").classList.add("full-width");
    // } else if (type == "default") {
    //   buttonGame.classList.add("created-default");
    //   document.querySelector(".ctn-button-default").classList.add("full-width");
    // }
  },
  computed: {
    styleButton() {
      let type = this.typeLogin;
      let social = this.social;
      if (type == "social") {
        if (social == "facebook") {
          this.classStart = "action-start-facebook";
          this.classFinish = "action-finish-facebook";
        } else if (social == "google") {
          this.classStart = "action-start-google";
          this.classFinish = "action-finish-google";
        }
      } else if (type == "email") {
        this.classStart = "action-start-email";
        this.classFinish = "action-finish-email";
      } else if (type == "default") {
        this.classStart = "action-start-default";
        this.classFinish = "action-finish-default";
      }
    }
  },
  methods: {
    async buttonToggle() {
      // let buttonGame = this.$refs.buttonGame;
      // let self = this;
      // let social = this.social;

      // buttonGame.classList.add(this.classStart);
      // await setTimeout(function() {
      //   buttonGame.classList.remove(self.classStart);
      //   buttonGame.classList.add(self.classFinish);
      // }, 200);
      // await buttonGame.classList.remove(self.classFinish);
      Bus.$emit(this.action);
    }
  }
};
</script>
<style lang="scss" scoped>
.ctn-button {
  width: 49%;
}

.ctn-button-social {
    width: 49%;
}

.ctn-button-email {
    display: flex;
    align-items: center;
    justify-content: center;  
        width: 100%;
}

.full-width {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-game {
  // min-width: 300px;
  background-color: #fbf872;
  width: 100%;
  max-width: 260px;
  border: none;
  padding: 13px 0 18px;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  color: #fff;
  // color: #30353a;
  // border-top: 7px #fbf872 solid;
  border-bottom: 4px #cecece solid;
  outline: none;
  vertical-align: middle;
  display: flex;
  justify-content: space-around;
  box-sizing: border-box;
  margin: 10% 0;
  border-radius: 50px;
}

.container-img-social {
  height: 100%;
}

.img-social {
  height: 25px;
  margin-left: 5px;
  vertical-align: middle;
}

.created-email {
  margin: 40px 0;
}

.created-facebook,
.created-google {
  width: 100%;
  font-size: 12px;
  padding: 2px 0 8px 0;
  letter-spacing: 0px;
  max-height: 150px;
  -webkit-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
  -moz-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
  box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
  display: flex;
  align-items: center;
  max-height: 47px;
  .text-button {
    font-weight: 300;
    text-transform: initial;
    span {
      font-weight: bold;
      text-transform: capitalize;
      margin-right: 5px;
    }
  }
}

.created-facebook {
  background-color: #4862a1;
  border-top: 6px #4862a1 solid;
  border-bottom: 6px #3a507c solid;
  color: white;

  .text-button {
    font-size: 11px;
  }
}

.created-google {
  background-color: #f4f4f4;
  border-top: 6px #f4f4f4 solid;
  border-bottom: 6px #c6c6c6 solid;
  color: #404040;

  .text-button {
    font-size: 11px;
  }
}

.action-start-default {
  width: 100%;
  padding: 15px 0 10px;
  border-top: 7px #404040f3 solid;
  border-bottom: 7px #fbf872 solid;
  box-shadow: transparent;
}

.action-start-email {
  padding: 15px 0 10px;
  border-top: 7px white solid;
  border-bottom: 7px #fbf872 solid;
  box-shadow: transparent;
}

.action-finish-email {
  padding: 10px 0 15px;
  border-top: 7px #fbf872 solid;
  border-bottom: 7px #d8d365 solid;
  -webkit-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
  -moz-box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
  box-shadow: 0px 6px 5px 0px rgba(230, 230, 230, 1);
}

.action-start-facebook {
  border-top: 6px white solid;
  border-bottom: 6px #4862a1 solid;

  .text-button {
    margin-top: 10px;
  }

  .img-social {
    padding-top: 5px;
  }
}

.action-finish-facebook {
  border-top: 6px #4862a1 solid;
  border-bottom: 6px #3a507c solid;
}

.action-start-google {
  border-top: 6px white solid;
  border-bottom: 6px #f4f4f4 solid;

  .text-button {
    margin-top: 10px;
  }

  .img-social {
    padding-top: 5px;
  }
}

.action-finish-google {
  border-top: 6px #f4f4f4 solid;
  border-bottom: 6px #c6c6c6 solid;
}
</style>
